<template>
  <div class="container-fluid">
    <selector class="mb-4" :items="listDeselected" @selected="select" />
    <p v-if="label" class="ml-3 font-16 font-weight-normal color-secondary-6">
      {{ label }}
    </p>
    <div class="d-flex flex-wrap">
      <div v-for="(item, index) in listSelected" :key="item.label">
        <chip highlight :title="item.label" @delete="deselect(item, index)" />
      </div>
    </div>
  </div>
</template>

<script>
import Selector from './Selector';
import Chip from './Chip';

export default {
  name: 'ContainerMultiSelection',
  components: {
    Selector,
    Chip,
  },
  props: {
    listItems: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      items: JSON.parse(JSON.stringify(this.listItems)),
      listSelected: [],
    };
  },
  computed: {
    listDeselected() {
      return this.items.filter((item) => !item.selected);
    },
  },
  watch: {
    listSelected(newValue) {
      this.$emit('input', newValue);
    },
  },
  mounted() {
    this.listSelected = this.items.filter((item) => item.selected);
  },
  methods: {
    select(element) {
      element.selected = true;
      this.listSelected.push(element);
    },
    deselect(element, index) {
      element.selected = false;
      this.listSelected.splice(index, 1);
    },
  },
};
</script>
